import React from 'react';
import { COMPETITION_ROUTES, ROUTES } from '@/constants/routes';
import { MenuItem, MenuWrapper } from './MenuWrapper';
import { ContactInfo } from './ContactInfo';

export default function Footer() {

  const mainMenuItems: MenuItem[] = [
    {
      label: 'Home',
      href: ROUTES.HOME,
    },
    {
      label: 'Philosophy',
      href: ROUTES.PHILOSOPHY,
    },
    {
      label: 'Sponsor',
      href: ROUTES.SPONSOR,
    },
    {
      label: 'Media Partner',
      href: ROUTES.MEDIA_PARTNER,
    },
    {
      label: 'Partner',
      href: '',
    },
    {
      label: 'Bazaar',
      href: ROUTES.BAZAAR,
    },
    {
      label: 'News',
      href: ROUTES.NEWS,
    },
    {
      label: "Procedure", 
      href: ROUTES.TERMS, 
    },
    {
      label: 'Register',
      href: ROUTES.REGISTER,
      external: true,
    },
  ];

  const eventMenuItems: MenuItem[] = [
    {
      label: 'Timeline',
      href: ROUTES.TIMELINE,
    },
    {
      label: 'Competition',
      href: ROUTES.EVENT_COMPETITION,
    },
    {
      label: 'Panelists',
      href: ROUTES.EVENT_PANELISTS,
    },
    {
      label: 'Workshop',
      href: ROUTES.WORKSHOP,
    },
    {
      label: 'Prizes',
      href: ROUTES.PRIZES,
    },
    {
      label: 'Certificate',
      href: ROUTES.CERTIFICATE,
    },
  ];

  const galleryMenuItems: MenuItem[] = [
    {
      label: 'Photos',
      href: ROUTES.GALLERY_PHOTOS,
    },
    {
      label: 'Testimonials',
      href: ROUTES.GALLERY_TESTIMONIALS,
    },
  ];

  const iitChallengeItems: MenuItem[] = [
    {
      label: 'Scratch Coding Game',
      href: COMPETITION_ROUTES.SCRATCH2026
    },
    // {
    //   label: 'Scratch Coding',
    //   href: COMPETITION_ROUTES.SCRATCH
    // },
    // {
    //   label: 'Duel in Vibe Coding',
    //   href: COMPETITION_ROUTES.DUEL
    // },
    {
      label: 'Competitive Programming',
      href: COMPETITION_ROUTES.COMPETITIVE_PROGRAMMING2026
    },
    {
      label: 'Innovative Technology Challenge',
      href: COMPETITION_ROUTES.INNOVATIVE_TECHNOLOGY2026
    },
    {
      label: 'EcoQuest Web Application',
      href: COMPETITION_ROUTES.ECOQUEST2026
    },
    // {
    //   label: 'Innovative Technology Challenge',
    //   href: COMPETITION_ROUTES.INNOVATIVE
    // },
    // {
    //   label: 'Design Dash - Mobile UI/UX Quest',
    //   href: COMPETITION_ROUTES.DESIGN_DASH
    // },
    // {
    //   label: 'Obstacles for Creating UI/UX Mobile Application',
    //   href: '/iit-program?program=Obstacle-Robot'
    // },
  ];

  return (
    <footer className="py-12 mt-24 w-full bg-gray-300">
      <div className="flex flex-col lg:flex-row justify-between gap-10 lg:gap-12 px-6">
        {/* Contact Section */}
        <div className="w-full lg:w-[28%]">
          <ContactInfo />
        </div>

        {/* Menu Section */}
        <div className="w-full lg:flex-1 gap-8 lg:gap-16 grid grid-cols-2 lg:grid-cols-4">
          <MenuWrapper title="Main Menu" items={mainMenuItems} />
          <MenuWrapper title="Competition" items={iitChallengeItems} />
          <MenuWrapper title="Gallery" items={galleryMenuItems} />
          <MenuWrapper title="Event" items={eventMenuItems} />
        </div>
      </div>
    </footer>
  );
}
